import { employeeMiniProfile } from 'interfaces/EmployeeMiniProfile';
import { z } from 'zod';

import { OneOnOneNotes } from './OneOnOneNotes';

export const OneOnOneAgenda = z.object({
  templateAgendaId: z.number().nullable(),
  instanceDataId: z.number().nullable(),
  ownerDetails: employeeMiniProfile.nullable(),
  privateNotes: OneOnOneNotes.nullable(),
  sharedNotes: OneOnOneNotes.nullable(),
  agendaText: z.string().nullable(),
  isCompleted: z.boolean().nullable(),
  referenceId: z.number().nullable(),
  referenceType: z.enum(['CUSTOM', 'GOAL', 'INITIATIVE', 'COMPETENCY']).nullable(),
  isOwnerAdmin: z.boolean().nullable().default(false),
  createdTs: z.number().nullable(),
  displayOrder: z.number().nullable(),
  isCarriedForward: z.boolean().nullable().optional(),
});

export const OneOnOneCreatedAgenda = z.object({
  agendaText: z.string().nullable(),
  id: z.number().nullable(),
  instanceId: z.number().nullable(),
});
